/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderVariance
 */
export interface OrderVariance {
    /**
     * 
     * @type {string}
     * @memberof OrderVariance
     */
    kind: OrderVarianceKindEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderVariance
     */
    direction: OrderVarianceDirectionEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderVariance
     */
    actualValue: number;
    /**
     * 
     * @type {number}
     * @memberof OrderVariance
     */
    averageValue: number;
    /**
     * 
     * @type {number}
     * @memberof OrderVariance
     */
    variancePercent: number;
    /**
     * 
     * @type {number}
     * @memberof OrderVariance
     */
    thresholdPercent: OrderVarianceThresholdPercentEnum;
    /**
     * Present for ORDER_VALUE only.
     * @type {string}
     * @memberof OrderVariance
     */
    currencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderVariance
     */
    sampleOrderCount: number;
}


/**
 * @export
 */
export const OrderVarianceKindEnum = {
    SkuCount: 'SKU_COUNT',
    OrderValue: 'ORDER_VALUE'
} as const;
export type OrderVarianceKindEnum = typeof OrderVarianceKindEnum[keyof typeof OrderVarianceKindEnum];

/**
 * @export
 */
export const OrderVarianceDirectionEnum = {
    BelowAverage: 'BELOW_AVERAGE',
    AboveAverage: 'ABOVE_AVERAGE'
} as const;
export type OrderVarianceDirectionEnum = typeof OrderVarianceDirectionEnum[keyof typeof OrderVarianceDirectionEnum];

/**
 * @export
 */
export const OrderVarianceThresholdPercentEnum = {
    NUMBER_30: 30,
    NUMBER_50: 50,
    NUMBER_75: 75,
    NUMBER_100: 100
} as const;
export type OrderVarianceThresholdPercentEnum = typeof OrderVarianceThresholdPercentEnum[keyof typeof OrderVarianceThresholdPercentEnum];


/**
 * Check if a given object implements the OrderVariance interface.
 */
// @ts-ignore
export function instanceOfOrderVariance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "direction" in value;
    isInstance = isInstance && "actualValue" in value;
    isInstance = isInstance && "averageValue" in value;
    isInstance = isInstance && "variancePercent" in value;
    isInstance = isInstance && "thresholdPercent" in value;
    isInstance = isInstance && "sampleOrderCount" in value;

    return isInstance;
}

// @ts-ignore
export function OrderVarianceFromJSON(json: any): OrderVariance {
    return OrderVarianceFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderVarianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderVariance {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'direction': json['direction'],
        'actualValue': json['actual_value'],
        'averageValue': json['average_value'],
        'variancePercent': json['variance_percent'],
        'thresholdPercent': json['threshold_percent'],
        'currencyCode': !exists(json, 'currency_code') ? undefined : json['currency_code'],
        'sampleOrderCount': json['sample_order_count'],
    };
}

// @ts-ignore
export function OrderVarianceToJSON(value?: OrderVariance | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'direction': value.direction,
        'actual_value': value.actualValue,
        'average_value': value.averageValue,
        'variance_percent': value.variancePercent,
        'threshold_percent': value.thresholdPercent,
        'currency_code': value.currencyCode,
        'sample_order_count': value.sampleOrderCount,
    };
}

